import { MarkdownParser } from '../MarkdownParser/index.js';
import * as React from 'react';
import { DismissButton } from './DismissButton.js';
import { Container, BadgeDismissingCard, BadgeContainer, Wrap, Text } from './styles.js';

const SubscriptionBadge = ({ className , onClick , onDismiss , children , icon , bodyTemplate , dismissedText , undoButtonText  })=>/*#__PURE__*/ React.createElement(Container, {
        className: className
    }, /*#__PURE__*/ React.createElement(BadgeDismissingCard, {
        dismissedText: dismissedText,
        undoButtonText: undoButtonText,
        onDismiss: onDismiss,
        hasTimeout: true,
        hasUndo: true
    }, /*#__PURE__*/ React.createElement(BadgeContainer, null, /*#__PURE__*/ React.createElement(Wrap, {
        onClick: onClick
    }, icon, /*#__PURE__*/ React.createElement(Text, null, /*#__PURE__*/ React.createElement(MarkdownParser, null, bodyTemplate))), /*#__PURE__*/ React.createElement(DismissButton, null))), children);

export { SubscriptionBadge };
